/**
 * QuickPotencialModal — Alta rápida de un cliente potencial (Auditoría
 * 2026-08-27, CAMBIO 7). Solo nombre + origen, sin exigir RUC/CI (a
 * diferencia del alta completa en ClienteFormModal) — se completa después.
 */
import { useState } from "react";
import ClienteIdentidadAviso, { useIdentidadCliente } from "./ClienteIdentidadAviso";
import { createPortal } from "react-dom";
import { X, Loader2, UserPlus } from "lucide-react";
import axios from "axios";
import { API } from "../contexts/AuthContext";
import { toast } from "sonner";

const inputCls =
  "w-full px-3 py-2 text-[13px] rounded-xl border border-gray-200 bg-white focus:border-gray-400 focus:outline-none focus:ring-2 focus:ring-amber-400/30";

export default function QuickPotencialModal({ onClose, onSaved }) {
  const [cliente, setCliente] = useState("");
  const [origen, setOrigen] = useState("");
  const [saving, setSaving] = useState(false);
  const identidad = useIdentidadCliente(cliente);

  const submit = async (e) => {
    e.preventDefault();
    if (!cliente.trim()) { toast.error("El nombre del cliente potencial es obligatorio"); return; }
    setSaving(true);
    try {
      const r = await axios.post(`${API}/listas/clientes`, { cliente, origen, estado: "potencial" });
      toast.success(`Cliente potencial creado · ${r.data.codigo}`);
      onSaved?.(r.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al crear el cliente potencial");
    } finally { setSaving(false); }
  };

  return createPortal(
    <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm" data-testid="quick-potencial-modal">
        <div className="flex items-center justify-between px-5 py-3.5 border-b border-gray-100">
          <h3 className="text-[15px] font-bold text-gray-900 flex items-center gap-2">
            <UserPlus size={16} className="text-amber-500" /> Alta Rápida — Cliente Potencial
          </h3>
          <button onClick={onClose} className="p-1 rounded-lg hover:bg-gray-100 text-gray-500" data-testid="quick-potencial-close"><X size={18} /></button>
        </div>
        <form onSubmit={submit} className="p-5 space-y-3">
          <div>
            <label className="block text-[11.5px] font-semibold text-gray-700 mb-1 uppercase tracking-wide">
              Nombre <span className="text-red-500">*</span>
            </label>
            <input className={inputCls} value={cliente} autoFocus onChange={(e) => setCliente(e.target.value)}
              placeholder="Ej: Constructora Olimpo S.A." data-testid="quick-potencial-nombre" />
          </div>
          <div>
            <label className="block text-[11.5px] font-semibold text-gray-700 mb-1 uppercase tracking-wide">Origen</label>
            <input className={inputCls} value={origen} onChange={(e) => setOrigen(e.target.value)}
              placeholder="Referido, web, licitación..." data-testid="quick-potencial-origen" />
          </div>
          <ClienteIdentidadAviso {...identidad} onElegir={onSaved} />
          <div className="flex justify-end gap-2 pt-2">
            <button type="button" onClick={onClose} className="px-4 py-2 rounded-xl text-[13px] font-semibold text-gray-600 hover:bg-gray-100">Cancelar</button>
            <button type="submit" disabled={saving}
              className="px-4 py-2 rounded-xl text-[13px] font-semibold text-white bg-amber-500 hover:brightness-110 disabled:opacity-50 inline-flex items-center gap-1.5"
              data-testid="quick-potencial-save">
              {saving ? <Loader2 size={14} className="animate-spin" /> : "Crear"}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}
